module.exports = __webpack_public_path__ + "static/media/national-junior-college-1024x683.6778b903.jpg";